import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface CustomSwitchOption<T extends string> {
  value: T;
  labelKey: string;
}

interface CustomSwitchProps<T extends string> {
  options: [CustomSwitchOption<T>, CustomSwitchOption<T>];
  value: T;
  onToggle: (val: T) => void;
}

export function CustomSwitch<T extends string>({ options, value, onToggle }: CustomSwitchProps<T>) {
  const { t } = useTranslation();
  const [optionA, optionB] = options;

  const itemStyle = (active: boolean) => ({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2px 0.5em',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: '0.2s all ease',
    backgroundColor: active ? '#fff' : 'transparent',
    '&:hover': {
      backgroundColor: active ? '#fff' : 'rgba(0,0,0,0.04)',
    },
  });

  const handleToggle = (val: T) => {
    if (val !== value) {
      onToggle(val);
    }
  };

  return (
    <Stack
      direction='row'
      sx={{
        borderRadius: '14px',
        overflow: 'hidden',
        backgroundColor: '#eeeeee',
        userSelect: 'none',
        padding: '0.2em',
      }}
    >
      <Stack
        onClick={() => handleToggle(optionA.value)}
        justifyContent='center'
        sx={itemStyle(value === optionA.value)}
      >
        <Typography variant='body2'>{t(optionA.labelKey)}</Typography>
      </Stack>
      <Stack
        onClick={() => handleToggle(optionB.value)}
        justifyContent='center'
        sx={itemStyle(value === optionB.value)}
      >
        <Typography variant='body2'>{t(optionB.labelKey)}</Typography>
      </Stack>
    </Stack>
  );
}
